import { getUserIdSuffix } from 'Foundation/Configurations/GlobalConfiguration';
import { useUserData } from 'Foundation/User/UserContext';
import { useState } from 'react';
import { DeleteUserPreferences, GetUserPreferences } from './Helpers/AdminApi';

export function UserPreferences() {
  const { userData } = useUserData();
  const [agentId, setAgentId] = useState('');
  const [userPref, setUserPref] = useState<any>(null);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  function onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      onSubmit();
    }
  }
  async function onSubmit() {
    if (agentId !== '') {
      setUserPref(null);
      let newId = agentId;
      if (agentId.search('@') === -1 && userData) {
        newId += getUserIdSuffix(userData.isBL());
      }
      const userPref = await GetUserPreferences(newId);
      if (userPref) {
        if (userPref?.UserID && userPref.UserID !== '') {
          setAgentId(userPref.UserID);
        } else {
          setAgentId(newId);
        }
        setUserPref(userPref);
        setError('');
      } else {
        setError('Agent ID not found');
        setAgentId(newId);
      }
    }
  }
  async function onDelete() {
    if (userPref?.UserID && userPref.UserID !== '') {
      if (window.confirm('You sure you want to delete this record?') === true) {
        const deleted = await DeleteUserPreferences(userPref.UserID);
        if (deleted) {
          setUserPref(null);
          setStatus('Deleted Successfully');
        } else {
          setError('Something went wrong during the delete');
        }
      }
    }
  }
  return (
    <>
      {!userData?.isAgent() && (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <div className="form-group mb-1">
            <div id="userPrefSection" className="input-group" style={{ maxWidth: '50%' }}>
              <input
                title="Agent ID"
                placeholder="Agent ID"
                aria-label="Agent ID"
                value={agentId}
                onKeyDown={(e) => onKeyDown(e)}
                onChange={(e) => setAgentId(e.target.value)}
                type="text"
                className="form-control"
              />
              <span className="input-group-btn">
                <button className="btn btn-default" id="usernamebtn" onClick={onSubmit} type="button">
                  Search
                </button>
              </span>
            </div>
          </div>
          <div>
            {error !== '' && (
              <div id="userPrefAuthError" className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            {status !== '' && (
              <div id="userPrefAuthError" className="alert alert-success" role="alert">
                {status}
              </div>
            )}
            {userPref && (
              <>
                <button className="btn btn-default" id="deletebtn" onClick={() => onDelete()} type="button">
                  Delete User Preference
                </button>
                <pre>{JSON.stringify(userPref, null, 2)}</pre>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
